const actions = {
    LOAD_DOCTORS: "LOAD_DOCTORS",
    DOCTORS_ARE_LOADING: "DOCTORS_ARE_LOADING",

    SET_DOCTOR_ITEM_VALUE: "SET_DOCTOR_ITEM_VALUE",
    DOCTOR_IS_SUBMITTING: "DOCTOR_IS_SUBMITTING",
    DOCTOR_CREATE_FAILED: "DOCTOR_CREATE_FAILED",
    DOCTOR_UPDATE_FAILED: 'DOCTOR_UPDATE_FAILED',
    SET_DOCTOR_ITEM: "SET_DOCTOR_ITEM",

    LOAD_DOCTOR_DETAIL: "LOAD_DOCTOR_DETAIL",
    DOCTOR_DETAIL_IS_LOADING: "DOCTOR_DETAIL_IS_LOADING",

    LOAD_PROFESSIONS: "LOAD_PROFESSIONS",
    PROFESSIONS_ARE_LOADING: "PROFESSIONS_ARE_LOADING"
  };
  export default actions;


// WEBPACK FOOTER //
// ./src/redux/constants/admin/doctors.js